/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Onl_SizeInputs */

const en_vc_onl_size = /** @type {(inputs: Vc_Onl_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`About 24 MB the first time, then cached by your browser.`)
};

const zh_vc_onl_size = /** @type {(inputs: Vc_Onl_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`首次加载约 24 MB，之后浏览器会缓存。`)
};

/**
* | output |
* | --- |
* | "About 24 MB the first time, then cached by your browser." |
*
* @param {Vc_Onl_SizeInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_onl_size = /** @type {((inputs?: Vc_Onl_SizeInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Onl_SizeInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_onl_size(inputs)
	return zh_vc_onl_size(inputs)
});
export { vc_onl_size as "vc.onl.size" }